// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__dr0t2","disabled":"styles_disabled__LxsHr","loading":"styles_loading__95K48","rotate":"styles_rotate__WNk3i"};